import { camelizeKeys } from 'humps';

import { logError } from '../LoggingService/LoggingService';
import { appRoot } from '../UrlGeneratorService/UrlGeneratorService';

export const enum AccessTokenError {
  Unauthorized = 'Unauthorized',
  ErrorFetchingAccessToken = 'Error fetching access token',
  RateLimitReached = 'Rate limit reached',
}

export const fetchAccessToken = async () => {
  const response = await fetch(`${appRoot()}/oauth2/access_token`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      grant_type: 'TL.authentication.oauth2.session_grant',
      client_id: 'web_app',
      client_secret: '',
    }),
  });

  if (response.status === 401 || response.status === 400) {
    throw new Error(AccessTokenError.Unauthorized);
  }

  if (response.status === 429) {
    logError(response.status);
    throw new Error(AccessTokenError.RateLimitReached);
  }

  if (response.status !== 200) {
    throw new Error(AccessTokenError.ErrorFetchingAccessToken);
  }

  const json = await response.json();

  return camelizeKeys(json);
};
